import React, { Component } from 'react'
import { connect } from 'react-redux';
import FormInputText from './../components/FormInputText'
import { Route, Redirect } from 'react-router-dom';
import {Grid, Button} from '@material-ui/core';
import {loginRequest} from '../store/actions'

class LoginForm extends Component {
    constructor(props) {
        super(props);

         this.state = {redirectToReferrer: false};

        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleSubmit(event) {
        event.preventDefault();
        this.props.dispatchLoginAction(this.state.username.state.defaultValue,this.state.password.state.defaultValue,this.props.tokenClient)
    }

    render() {
        
        let isUserLogged = sessionStorage.getItem("isUserLogged")
        const BgMask = (props) => {
            const preventDefault = (event) => event.preventDefault();

         
            return (
                isUserLogged?
                <Redirect to={{pathname:`/${this.props.tokenClient}/trenes/`}} /> :
                <Redirect to={{pathname:`/${this.props.tokenClient}/trenes/login`}} />
                           
            ) 
        }

        return (
               
                <div className="loginform-container">
                <BgMask className="bgMask bgLogin" />
                <form  onSubmit={this.handleSubmit}>
                    <Grid container>
                       
                        <Grid item xs={12}>
                            <FormInputText
                                id="username"
                                name="username"
                                label="Usuario"
                                defaultValue={this.state.username}   
                                ref={element => { this.state.username = element }}      
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <FormInputText
                                id="password"
                                name="password"
                                label="Contraseña"
                                defaultValue={this.state.password}  
                                type="password"  
                                ref={element => { this.state.password = element }}                 
                            />
                        </Grid>
                        {this.props.error}
                        <Grid item xs={12}>
                            <Button type="submit" fullWidth variant="contained" color="primary" >
                                Iniciar Sesión
                            </Button>
                        </Grid>

                    </Grid>
                </form>
            </div>
            
           
        )
    }
}

const mapStateToProps = reducers => {
    return reducers.loginReducer
};

const mapDispatchToProps = dispatch => {
    return {
        dispatchLoginAction: (username,password,tokenClient) => { dispatch(loginRequest(username,password,tokenClient)) },
    };
}


export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(LoginForm);
